import store from "@/store/auth";
import Auth from "@/store/auth";

let Items = function() {
  this.get = function(groupId) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API + "comparison_groups/" + groupId + "/items/";

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            let items = {};
            for (let pos in json) {
              if (Object.prototype.hasOwnProperty.call(json, pos)) {
                items[json[pos].competitorId] = json[pos];
              }
            }
            resolve(items);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  };

  this.addByItemDefinition = function(
    groupId,
    competitorId,
    name,
    itemDefinition,
    onlyFirstItem
  ) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API + "comparison_groups/" + groupId + "/items/";

      let data = {
        competitorId: competitorId,
        name: typeof name == "undefined" ? "" : name,
        itemDefinition: itemDefinition,
        onlyFirstItem: onlyFirstItem
      };

      fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.result);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  };

  this.removeItem = function(groupId, itemId) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API + "comparison_groups/" + groupId + "/items/";

      let data = {
        itemId: itemId
      };
      fetch(url, {
        method: "Delete",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.result);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
        }
      });
    });
  };
};

export default new Items();
